// Approved product pages only; Pixel is the only HTTP sender.
(() => {
  if (window.__anonaBehaviorTracking) return;
  let settings;
  try { settings = JSON.parse(document.getElementById('anona-tracking-config')?.textContent || '{}'); } catch { return; }
  const productPath = settings.product_path;
  if (!/^\/products\/[a-z0-9][a-z0-9-]*$/.test(productPath || '') || window.location.pathname !== productPath) return;
  const themeId = String(window.Shopify?.theme?.id || '');
  const themeRole = ['main', 'unpublished', 'development'].includes(settings.theme_role) ? settings.theme_role : 'unknown';
  const pageMode = themeRole === 'main' ? 'storefront' : 'preview';
  const trafficType = themeRole === 'main' ? 'customer' : 'test';
  if (settings.enabled === false || settings.theme_id !== themeId ||
      settings.release_id !== 'products-v9-20261019' || settings.collector_version !== '9' ||
      settings.design_mode !== false || settings.visual_preview_mode !== false ||
      window.Shopify?.designMode || window.Shopify?.visualPreviewMode ||
      !['www.anonasecurity.com', 'anonasecurity.com', '521a35-2.myshopify.com'].includes(window.location.hostname) ||
      !/^[1-9][0-9]{0,19}$/.test(settings.product_id || '') || !Array.isArray(settings.variants) ||
      !Array.isArray(settings.features)) return;
  let exclusionLatched = false;
  let exclusionIdentity;
  function excluded() {
    const previous = exclusionLatched;
    try { exclusionLatched = exclusionLatched || window.sessionStorage?.getItem('anona_tracking_excluded') === 'true'; }
    catch { exclusionLatched = true; }
    if (!previous && exclusionLatched && exclusionIdentity) {
      // Stop the Pixel's standard-success stream too; the marker is terminal until reload.
      try { void Promise.resolve(window.Shopify?.analytics?.publish?.('anona:tracking_excluded', exclusionIdentity)).catch(() => {}); } catch {}
    }
    return exclusionLatched;
  }
  if (excluded()) return;
  if (typeof window.crypto?.randomUUID !== 'function') return;
  const variants = new Map(settings.variants.filter(v => /^[1-9][0-9]{0,19}$/.test(v.id)).map(v => [v.id, v]));
  // ponytail: browser signals give an approximate category, not hardware identity; never use viewport width.
  const nav = window.navigator;
  const ua = nav?.userAgent || '';
  const deviceType = /iPad|Tablet|Silk/i.test(ua) || (/Macintosh/i.test(ua) && nav?.maxTouchPoints > 1) ||
    (/Android/i.test(ua) && !/Mobile/i.test(ua)) ? 'tablet' :
    nav?.userAgentData?.mobile === true || /Mobi|iPhone|iPod/i.test(ua) ? 'mobile' :
    /Windows NT|Macintosh|X11|CrOS/i.test(ua) ? 'desktop' : 'unknown';
  const identity = Object.freeze({
    device_type: deviceType, schema_version: 9, theme_id: themeId, release_id: settings.release_id,
    collector_version: '9', product_id: settings.product_id, page_instance_id: window.crypto.randomUUID(),
    page_mode: pageMode, theme_role: themeRole, traffic_type: trafficType,
  });
  exclusionIdentity = identity;
  window.__anonaBehaviorTracking = true;
  let permitted = false, observer, observed = new WeakSet(), pageViewed = false, pagePublishing = false;
  let lastVariant, lastQuantity, lastMedia, galleryIntent = -Infinity, quantityIntent = -Infinity, variantIntent = -Infinity;
  const timers = new Map(), viewed = new Set(), publishingViews = new Set(), depths = new Set(), pendingDepths = new Set();
  let expanding = new WeakSet();
  const played = new Set(), pendingPlays = new Set();
  let mediaPlayIntent = new WeakMap();
  let featureIntent = new WeakMap();
  const featureSelection = new WeakMap();
  const active = () => permitted && !excluded() && document.visibilityState === 'visible' && window.location.pathname === productPath;
  const main = () => document.querySelector('.shopify-section--main-product');
  const form = () => main()?.querySelector('form[is="product-form"]');
  const gallery = () => main()?.querySelector('product-gallery');
  const selection = () => {
    const current = form();
    const variantId = current ? String(current.elements.namedItem('id')?.value || '') : settings.initial_variant_id;
    const rawQuantity = current?.elements.namedItem('quantity')?.value ?? '1';
    const quantity = /^[1-9][0-9]{0,6}$/.test(rawQuantity) && Number(rawQuantity) <= 1000000 ? Number(rawQuantity) : undefined;
    return { variant: variants.get(variantId), quantity };
  };
  const productFields = () => {
    const { variant, quantity } = selection();
    return {
      product_id: settings.product_id, product_name: settings.product_name, variant_id: variant?.id,
      quantity: quantity === undefined ? undefined : String(quantity),
      price_subunits: variant?.price_subunits, currency: settings.currency,
    };
  };
  // Bounded retries reuse one immutable snapshot and one business ID. Shopify's
  // transport event.id changes on each publish and therefore cannot deduplicate it.
  let privacyEpoch = 0;
  const publications = new Map();
  function cancelPublications() {
    for (const item of publications.values()) { clearTimeout(item.timer); clearTimeout(item.deadline); item.cancelAttempt?.(); item.finish(false); }
    publications.clear();
  }
  function publish(topic, data = {}) {
    if (!permitted || excluded() || publications.size >= 50) return Promise.resolve(false);
    const epoch = privacyEpoch;
    const snapshot = Object.freeze(JSON.parse(JSON.stringify({ ...data, ...identity,
      ...(topic === 'anona:behavior' ? { event_id: window.crypto.randomUUID(), occurred_at: new Date().toISOString() } : {}) })));
    if (snapshot.properties) Object.freeze(snapshot.properties);
    return new Promise(resolve => {
      const key = snapshot.event_id || window.crypto.randomUUID();
      const item = { attempts: 0, timer: undefined, finish: resolve };
      publications.set(key, item);
      const attempt = async () => {
        if (!permitted || epoch !== privacyEpoch || !publications.has(key) || excluded()) { publications.delete(key); resolve(false); return; }
        item.attempts++;
        let success = false;
        try { success = typeof window.Shopify?.analytics?.publish === 'function' &&
          await Promise.race([window.Shopify.analytics.publish(topic, snapshot),
            new Promise(done => { item.cancelAttempt = () => done(false); item.deadline = setTimeout(() => done(false), 3000); })]) === true; } catch {}
        clearTimeout(item.deadline); item.cancelAttempt = undefined;
        if (!permitted || epoch !== privacyEpoch || !publications.has(key) || excluded()) { publications.delete(key); resolve(false); return; }
        if (success || item.attempts >= 3) { publications.delete(key); resolve(success); }
        else item.timer = setTimeout(attempt, item.attempts * 1000);
      };
      void attempt();
    });
  }
  const behavior = data => {
    const fields = { ...productFields(), ...data };
    if (['add_to_cart_clicked', 'buy_now_clicked', 'checkout_clicked', 'variant_changed', 'quantity_changed'].includes(fields.event_name) &&
        (!variants.has(fields.variant_id) || !/^[1-9][0-9]{0,6}$/.test(fields.quantity || ''))) return Promise.resolve(false);
    return publish('anona:behavior', fields);
  };
  const context = element => {
    const root = element.closest('[data-anona-product-region]');
    return {
      section_id: root?.dataset.trackSection, section_name: root?.dataset.trackSectionName,
      element_id: element.dataset.trackId, element_name: element.dataset.trackName,
    };
  };
  function mark(root, id, name) {
    if (!root) return;
    Object.assign(root.dataset, { anonaProductRegion: 'true', trackSection: id, trackSectionName: name });
    // Measure representative visible content instead of requiring half of a multi-screen section.
    const selector = id === 'product_media' ? '[data-media-id]' : id === 'product_information' ? '.product-info__price' :
      id === 'product_reviews' ? '.jdgm-rev-widg__header' : 'h1, h2, h3, .h1, .h2, .h3, .iwa-heading';
    let targets = Array.from(root.querySelectorAll(selector));
    if (!targets.length) targets = Array.from(root.querySelectorAll('img'));
    if (!targets.length) targets = [root];
    for (const target of targets) Object.assign(target.dataset, { anonaViewEntry: 'true', trackId: id + '_view', trackName: name });
  }
  function action(element, name, id, label, properties) {
    if (!element) return;
    Object.assign(element.dataset, { anonaProductTrack: 'true', trackEvent: name, trackId: id, trackName: label });
    if (properties) element.dataset.trackProperties = JSON.stringify(properties);
  }
  const features = settings.features.filter(item => Array.isArray(item) && item.length === 3 &&
    /^[A-Za-z0-9_-]{1,80}$/.test(item[0]) && /^feature_[a-z0-9_]{1,64}$/.test(item[1]) &&
    typeof item[2] === 'string' && item[2].length <= 80);
  function configure() {
    const root = main();
    if (!root) return;
    mark(gallery(), 'product_media', 'Main product media');
    mark(root.querySelector('.product-info'), 'product_information', 'Purchase information');
    mark(root.querySelector('.product-info__variant-picker'), 'product_options', 'Package selection');
    mark(root.querySelector('.product-info__quantity-selector'), 'product_quantity', 'Quantity selection');
    const buy = root.querySelector('.product-info__buy-buttons');
    mark(buy, 'product_main', 'Main purchase controls');
    action(form()?.querySelector('button[type="submit"]'), 'add_to_cart_clicked', 'main_add_to_cart', 'Main add to cart');
    if (buy) {
      for (const element of buy.querySelectorAll('shopify-accelerated-checkout, .shopify-payment-button__button')) {
        action(element, 'checkout_clicked', 'main_accelerated_checkout', 'Accelerated checkout');
      }
      for (const element of buy.querySelectorAll('.shopify-payment-button__more-options')) {
        action(element, 'checkout_clicked', 'main_more_payment_options', 'More payment options');
      }
    }
    const sticky = root.querySelector('product-quick-add');
    mark(sticky, 'product_sticky', 'Sticky purchase controls');
    action(sticky?.querySelector('button[type="submit"]'), 'add_to_cart_clicked', 'sticky_add_to_cart', 'Sticky add to cart');
    action(sticky?.querySelector('a.checkout'), 'buy_now_clicked', 'sticky_buy_now', 'Sticky buy now');
    for (const [key, id, name] of features) {
      const section = document.querySelector('[id$="__' + key + '"]');
      mark(section, id, name);
      const carousel = section?.querySelector('slideshow-carousel');
      if (carousel && !featureSelection.has(carousel)) featureSelection.set(carousel, carousel.selectedIndex ?? 0);
      if (section) Array.from(section.querySelectorAll('.iwa-accordion-item, .media-tabs-custom__tab, .media-with-text-tabs .tab')).forEach((item, index) => {
        action(item, 'content_selected', id + '_item_' + (index + 1), name + ' option ' + (index + 1), { item_index: index + 1 });
      });
    }
    const faq = document.querySelector('.shopify-section--faq');
    mark(faq, 'product_faq', 'Product FAQ');
    for (const region of [root.querySelector('.product-info'), faq]) {
      if (!region) continue;
      Array.from(region.querySelectorAll('details')).forEach((details, index) => {
        action(details, 'content_expanded', (region === faq ? 'faq_' : 'information_') + (index + 1),
          (region === faq ? 'FAQ ' : 'Purchase information ') + (index + 1), { item_index: index + 1 });
      });
    }
    const reviews = document.getElementById('judgeme_product_reviews');
    mark(reviews, 'product_reviews', 'Customer reviews');
    if (reviews) {
      for (const [selector, kind] of [['.jdgm-write-rev-link', 'write'], ['.jdgm-paginate__page', 'paginate'],
        ['.jdgm-sort-dropdown', 'sort'], ['.jdgm-histogram__row', 'filter']]) {
        for (const element of reviews.querySelectorAll(selector)) {
          action(element, 'review_interacted', 'reviews_' + kind, 'Reviews ' + kind, { action: kind });
        }
      }
    }
    const expected = ['product_media','product_information','product_options','product_quantity','product_main','product_sticky',
      ...new Set(features.map(item => item[1])), 'product_faq','product_reviews'];
    window.__anonaTrackingCoverage = Object.freeze({ expected: Object.freeze(expected),
      missing: Object.freeze(expected.filter(id => !document.querySelector('[data-track-id="' + id + '_view"]'))) });
    observeViews();
  }
  function emitElement(element, snapshot = productFields()) {
    let properties;
    try { properties = element.dataset.trackProperties ? JSON.parse(element.dataset.trackProperties) : undefined; } catch { return; }
    let purchase = {};
    if (element.dataset.trackEvent === 'buy_now_clicked') {
      try {
        const target = new URL(element.getAttribute('href'), window.location.href);
        const match = target.origin === window.location.origin && target.pathname.match(/^\/cart\/([1-9][0-9]{0,19}):([1-9][0-9]{0,6})\/?$/);
        const variant = match && variants.get(match[1]);
        if (!variant || Number(match[2]) > 1000000) return;
        purchase = { variant_id: variant.id, quantity: match[2], price_subunits: variant.price_subunits };
      } catch { return; }
    }
    void behavior({ ...snapshot, event_name: element.dataset.trackEvent, ...context(element), ...purchase, ...(properties ? { properties } : {}) });
  }
  document.addEventListener('click', event => {
    if (!event.isTrusted || !active()) return;
    const target = event.target;
    const feature = target.closest?.('[data-anona-product-region]');
    if (feature?.dataset.trackSection?.startsWith('feature_')) featureIntent.set(feature, Date.now());
    if (gallery()?.contains(target)) {
      galleryIntent = Date.now();
      const media = target.closest?.('[data-media-id]');
      if (media && ['video', 'external_video'].includes(media.dataset.mediaType)) mediaPlayIntent.set(media, Date.now());
    }
    if (target.closest?.('.product-info__quantity-selector')) quantityIntent = Date.now();
    if (target.closest?.('.product-info__variant-picker')) variantIntent = Date.now();
    const summary = target.closest?.('summary');
    const details = summary?.closest('details');
    if (details?.dataset.anonaProductTrack && !details.open) expanding.add(details);
    const element = target.closest?.('[data-anona-product-track]');
    if (!element || element.closest(':disabled, [aria-disabled="true"]') || element.tagName === 'DETAILS' || element.tagName === 'SELECT') return;
    if (element.dataset.trackEvent === 'content_selected') {
      if (element.classList.contains('active')) return;
      // Capture before asynchronous work; only a real active-state transition counts.
      const fields = productFields(), epoch = privacyEpoch;
      Promise.resolve().then(() => {
        if (active() && epoch === privacyEpoch && element.classList.contains('active')) emitElement(element, fields);
      });
      return;
    }
    emitElement(element);
  }, true);
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!active() || !details.open || !expanding.has(details)) return;
    expanding.delete(details);
    emitElement(details);
  }, true);
  function recordQuantityChange() {
    const next = selection().quantity, previous = lastQuantity;
    if (next !== undefined) lastQuantity = next;
    if (active() && next && previous && next !== previous) {
      void behavior({ event_name: 'quantity_changed', section_id: 'product_quantity', section_name: 'Quantity selection',
        element_id: 'product_quantity', element_name: 'Quantity', properties: { previous_quantity: previous } });
    }
  }
  // The theme's +/- handlers set input.value without dispatching change. Read it
  // during bubbling, after those button handlers have applied the new quantity.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button');
    const region = button?.closest('.product-info__quantity-selector');
    if (!event.isTrusted || !region || button.closest(':disabled, [aria-disabled="true"]') ||
        region.querySelector('[name="quantity"]')?.form !== form()) return;
    recordQuantityChange();
  });
  document.addEventListener('change', event => {
    const target = event.target;
    if (target.name === 'quantity' && target.form === form()) {
      if (event.isTrusted || Date.now() - quantityIntent < 2000) recordQuantityChange();
      else lastQuantity = selection().quantity;
    } else if (active() && event.isTrusted && target.dataset.anonaProductTrack && target.tagName === 'SELECT') emitElement(target);
  });
  document.addEventListener('keydown', event => {
    if (event.isTrusted && active() && event.target.closest?.('.product-info__variant-picker')) variantIntent = Date.now();
  });
  document.addEventListener('variant:change', event => {
    if (event.target !== form()) return;
    const next = selection().variant?.id, previous = lastVariant;
    lastVariant = next;
    if (active() && Date.now() - variantIntent < 2000 && previous && next && previous !== next) void behavior({
      event_name: 'variant_changed', section_id: 'product_options', section_name: 'Package selection',
      element_id: 'product_variant', element_name: 'Package', properties: { previous_variant_id: previous },
    });
  });
  const mediaDetails = media => {
    if (!media || !gallery()?.contains(media)) return null;
    const mediaId = media.dataset.mediaId, type = media.dataset.mediaType;
    const index = Array.from(gallery().querySelectorAll('[data-media-id]')).indexOf(media) + 1;
    return /^[1-9][0-9]{0,19}$/.test(mediaId) && ['image', 'video', 'external_video', 'model'].includes(type) && index > 0 ?
      { media_id: mediaId, media_type: type, media_index: index } : null;
  };
  const emitMedia = (eventName, media) => {
    const properties = mediaDetails(media);
    if (active() && properties) return behavior({ event_name: eventName, section_id: 'product_media', section_name: 'Main product media',
      element_id: 'media_' + properties.media_id, element_name: 'Product media ' + properties.media_index, properties });
    return Promise.resolve(false);
  };
  for (const eventName of ['pointerdown', 'touchstart', 'keydown']) document.addEventListener(eventName, event => {
    if (event.isTrusted && active() && gallery()?.contains(event.target)) {
      galleryIntent = Date.now();
      const media = event.target.closest?.('[data-media-id]');
      if (media && ['video', 'external_video'].includes(media.dataset.mediaType)) mediaPlayIntent.set(media, Date.now());
    }
  }, { passive: true });
  document.addEventListener('carousel:change', event => {
    const feature = event.target?.closest?.('[data-anona-product-region]');
    if (event.target?.tagName === 'SLIDESHOW-CAROUSEL' && feature?.dataset.trackSection?.startsWith('feature_')) {
      const previous = featureSelection.get(event.target), next = event.detail?.index;
      if (Number.isInteger(next)) featureSelection.set(event.target, next);
      if (active() && Number.isInteger(next) && next >= 0 && next < 50 && next !== previous &&
          Date.now() - (featureIntent.get(feature) ?? -Infinity) < 2000) {
        void behavior({ event_name: 'content_selected', section_id: feature.dataset.trackSection,
          section_name: feature.dataset.trackSectionName, element_id: feature.dataset.trackSection + '_item_' + (next + 1),
          element_name: feature.dataset.trackSectionName + ' option ' + (next + 1), properties: { item_index: next + 1 } });
      }
      return;
    }
    if (event.target?.tagName !== 'MEDIA-CAROUSEL' || !gallery()?.contains(event.target)) return;
    const media = event.detail?.slide, next = media?.dataset.mediaId, previous = lastMedia;
    lastMedia = next;
    if (active() && previous && next !== previous && Date.now() - galleryIntent < 2000) emitMedia('media_changed', media);
  });
  document.addEventListener('lightbox:open', event => {
    if (!gallery()?.contains(event.target) || Date.now() - galleryIntent >= 2000) return;
    const images = Array.from(gallery().querySelectorAll('[data-media-type="image"]')).filter(item => !item.hidden);
    emitMedia('media_zoom_clicked', images[event.detail?.index]);
  });
  document.addEventListener('media:play', event => {
    const media = event.target.closest?.('[data-media-id]');
    const properties = mediaDetails(media);
    // Provider loading may exceed two seconds; require intent on this exact media.
    const intent = media ? mediaPlayIntent.get(media) : undefined;
    if (!active() || intent === undefined || Date.now() - intent > 30000 || !properties || !['video', 'external_video'].includes(properties.media_type) || played.has(properties.media_id) || pendingPlays.has(properties.media_id)) return;
    mediaPlayIntent.delete(media);
    const epoch = privacyEpoch; pendingPlays.add(properties.media_id);
    void emitMedia('media_played', media).then(success => {
      if (epoch !== privacyEpoch) return;
      if (success) played.add(properties.media_id);
      pendingPlays.delete(properties.media_id);
    });
  });
  function stopViews() {
    observer?.disconnect(); observer = undefined; observed = new WeakSet();
    for (const { timer } of timers.values()) clearTimeout(timer);
    timers.clear();
  }
  function observeViews() {
    if (!active() || typeof IntersectionObserver !== 'function') return;
    if (!observer) {
      const current = new IntersectionObserver(entries => {
        if (!active() || observer !== current) return;
        for (const entry of entries) {
          const id = entry.target.dataset.trackId;
          if ((!entry.isIntersecting || entry.intersectionRatio < 0.5) && timers.get(id)?.element === entry.target) {
            clearTimeout(timers.get(id).timer); timers.delete(id);
          }
        }
        for (const entry of entries) {
          const element = entry.target, id = element.dataset.trackId;
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || viewed.has(id) || timers.has(id) || publishingViews.has(id)) continue;
          const timer = setTimeout(async () => {
            timers.delete(id);
            if (!active() || observer !== current || !element.isConnected) return;
            publishingViews.add(id);
            const epoch = privacyEpoch;
            const success = await behavior({ event_name: 'section_viewed', ...context(element), properties: { visibility_percent: 50, visible_ms: 1000 } });
            if (epoch !== privacyEpoch) return;
            if (success) viewed.add(id);
            publishingViews.delete(id);
          }, 1000);
          timers.set(id, { element, timer });
        }
      }, { threshold: [0, 0.5] });
      observer = current;
    }
    for (const element of document.querySelectorAll('[data-anona-view-entry]')) {
      if (!viewed.has(element.dataset.trackId) && !observed.has(element)) { observer.observe(element); observed.add(element); }
    }
  }
  function scrollDepth() {
    if (!active()) return;
    const root = document.scrollingElement;
    if (!root || root.scrollHeight <= root.clientHeight) return;
    const percent = root.scrollTop / (root.scrollHeight - root.clientHeight) * 100;
    for (const depth of [25, 50, 75, 90]) if (percent >= depth && !depths.has(depth) && !pendingDepths.has(depth)) {
      pendingDepths.add(depth);
      const epoch = privacyEpoch;
      void behavior({ event_name: 'scroll_depth_reached', properties: { scroll_depth: depth } }).then(success => {
        if (epoch !== privacyEpoch) return;
        if (success) depths.add(depth);
        pendingDepths.delete(depth);
      });
    }
  }
  function setPermission(allowed) {
    const nextPermission = allowed === true;
    if (nextPermission === permitted) return;
    permitted = nextPermission;
    if (!permitted) {
      privacyEpoch++; cancelPublications(); stopViews();
      publishingViews.clear(); pendingDepths.clear(); pendingPlays.clear(); pagePublishing = false; expanding = new WeakSet();
      galleryIntent = quantityIntent = variantIntent = -Infinity;
      mediaPlayIntent = new WeakMap(); featureIntent = new WeakMap();
      return;
    }
    lastVariant = selection().variant?.id; lastQuantity = selection().quantity;
    lastMedia = gallery()?.querySelector('media-carousel')?.selectedSlide?.dataset.mediaId || settings.initial_media_id;
    void publish('anona:tracking_ready');
    if (!pageViewed && !pagePublishing) {
      pagePublishing = true;
      const epoch = privacyEpoch;
      void behavior({ event_name: 'product_viewed', section_id: 'product_page', section_name: 'Product page',
        element_id: 'product_page', element_name: 'Product page' }).then(success => { if (epoch === privacyEpoch) { pageViewed = success; pagePublishing = false; } });
    }
    // Thresholds already passed before consent are not reconstructed as user behavior.
    const scroll = document.scrollingElement;
    if (scroll && scroll.scrollHeight > scroll.clientHeight) {
      const baseline = scroll.scrollTop / (scroll.scrollHeight - scroll.clientHeight) * 100;
      for (const depth of [25,50,75,90]) if (baseline >= depth) depths.add(depth);
    }
    observeViews();
  }
  function readPermission(fallback) {
    try {
      const privacy = window.Shopify.customerPrivacy;
      setPermission(typeof privacy?.analyticsProcessingAllowed === 'function' ? privacy.analyticsProcessingAllowed() : fallback);
    } catch { setPermission(false); }
  }
  configure();
  // Coalesce dynamic sections/reviews instead of rescanning for every mutation.
  let configureTimer;
  if (typeof MutationObserver === 'function') new MutationObserver(records => {
    if (records && !records.some(record => record.addedNodes?.length || record.removedNodes?.length)) return;
    if (configureTimer !== undefined) return;
    configureTimer = setTimeout(() => { configureTimer = undefined; configure(); }, 100);
  }).observe(document.getElementById('main') || document.body, { childList: true, subtree: true });
  document.addEventListener('visitorConsentCollected', event => readPermission(event.detail?.analyticsAllowed));
  document.addEventListener('visibilitychange', () => { stopViews(); observeViews(); });
  window.addEventListener('resize', () => { stopViews(); observeViews(); }, { passive: true });
  window.addEventListener('scroll', scrollDepth, { passive: true });
  if (window.Shopify.customerPrivacy) readPermission();
  else if (typeof window.Shopify.loadFeatures === 'function') window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) readPermission(); });
})();
